import React from "react";

export default (
  <>
    <path d="M19.3301 8.37558L12.7436 14.166L9.94356 12.3199L5.33012 16.3756L4.66988 15.6245L9.85667 11.0648L12.6567 12.9109L18.6699 7.62454L19.3301 8.37558Z" />
    <path d="M18.5001 8.5H15.5V7.5H19.5001V11.0769H18.5001V8.5Z" />
  </>
);
